import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InitialsUpperPipe } from './pipes/initials-upper.pipe';
import { FormApiValidationErrorsComponent } from './components/form-api-validation-errors/form-api-validation-errors.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { GridFiltersComponent } from './dialogs/grid-filters/grid-filters.component';
import { CancelConfirmDialogComponent } from './dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { FiltersChimpComponent } from './components/filters-chimp/filters-chimp.component';
import { GridMenuComponent } from './components/grid-menu/grid-menu.component';
import { ApiModule } from './api/api.module';
import { FilterChimpTextComponent } from './components/filter-chimp-text/filter-chimp-text.component';
import { SendOrdersComponent } from './dialogs/send-orders/send-orders.component';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { QRDialogComponent } from './dialogs/QRDialog/QRcode-dialog.component';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { SuspendPrintComponent } from './dialogs/suspend-resume-print/components/suspend-print/suspend-print.component';
import { ResumePrintComponent } from './dialogs/suspend-resume-print/components/resume-print/resume-print.component';
import { SuspendPdfPrintComponent } from './dialogs/suspend-pdf-print/suspend-pdf-print.component';
import { CustomPaginatorComponent } from '../layout/buttoned-pagination/buttoned-pagination.component';
//import { CustomNgxDatetimeAdapter } from './adapters/datetime-adapter';
//import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DuplicateOrdersComponent } from './dialogs/duplicate-orders/duplicate-orders.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
//import { ReportGenereateDialogComponent } from './dialogs/report-genereate-dialog/report-genereate-dialog.component';
import { ReportFilterDialogComponent } from './dialogs/report-filter-dialog/report-filter-dialog.component';
import { SecondsToTimePipe } from './pipes/seconds-to-time.pip';
import { RouterModule } from '@angular/router';
import { NavigationListItemComponent } from '../layout/navigation-menu/components/navigation-list-item/navigation-list-item.component';
import { NavigationMenuItemComponent } from '../layout/navigation-menu/components/navigation-menu-item/navigation-menu-item.component';
import { NavigationMenuComponent } from '../layout/navigation-menu/navigation-menu.component';
import { HeaderComponent } from '../layout/header/header.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { UserMenuComponent } from '../layout/user-menu/user-menu.component';
import { BreadcrumbsNavComponent } from '../layout/breadcrumbs-nav/breadcrumbs-nav.component';
import { translateLoaderFactory } from 'src/app/i18n/i18n.module';
import { DatetimePicker } from './components/datetime-picker/datetime-picker';


@NgModule({
  declarations: [
    CustomPaginatorComponent,
    FilterChimpTextComponent,
    MessageDialogComponent,
    SuspendPrintComponent,
    ResumePrintComponent,
    SuspendPdfPrintComponent,
    CancelConfirmDialogComponent,
    GridFiltersComponent,
    SendOrdersComponent,
    QRDialogComponent,
    FiltersChimpComponent,
    GridMenuComponent,
    ReportFilterDialogComponent,
    DuplicateOrdersComponent,
    FormApiValidationErrorsComponent,
    //HeaderComponent,
    //CustomNgxDatetimeAdapter
  ],
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    RouterModule,
    BaseChartDirective,
    MaterialModule,
    LeafletModule,
    DatePipe,
    AsyncPipe,
    DatetimePicker,
    SecondsToTimePipe,
    InitialsUpperPipe,
    //FormApiValidationErrorsComponent,
    //NavigationMenuItemComponent,
    //NavigationListItemComponent,
    //NavigationMenuComponent,
    //BreadcrumbsNavComponent,
    //HeaderComponent,
    //FooterComponent,
    //DuplicateOrdersComponent,
    //ReportGenereateDialogComponent,
    RouterModule,
    //CustomNgxDatetimeAdapter,
    MatDatepickerModule,
    ReactiveFormsModule,
    //NgxMatDatetimePickerModule, // Add the datetime picker module here
    MatMomentDateModule, // Optionally, add Moment.js date adapter
    //NgxMatTimepickerModule,
    //NgxMatNativeDateModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    //NgxMatDatetimePickerModule, // Add the datetime picker module here
    MatMomentDateModule, // Optionally, add Moment.js date adapter
    //NgxMatTimepickerModule,
    //NgxMatNativeDateModule,
    //UserMenuComponent,
    //HeaderComponent,
    //FooterComponent,
    DatetimePicker,
    FormApiValidationErrorsComponent,
    RouterModule,
    LeafletModule,
    MatDatepickerModule,
    CommonModule,
    DatePipe,
    AsyncPipe,
    SecondsToTimePipe,
    InitialsUpperPipe,
    ApiModule,
    //FormApiValidationErrorsComponent,
    MaterialModule,
    ReactiveFormsModule,
    SecondsToTimePipe,
    InitialsUpperPipe,
    CancelConfirmDialogComponent,
    MessageDialogComponent,
    GridFiltersComponent,
    //NavigationMenuItemComponent,
    //NavigationListItemComponent,
    //NavigationMenuComponent,
    //BreadcrumbsNavComponent,
    TranslateModule,
    FiltersChimpComponent,
    GridMenuComponent,
    CustomPaginatorComponent,
    FilterChimpTextComponent
  ],
})
export class SharedModule {}
